<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">优惠券</div>
			<div class="right">
				<el-button size="mini" @click="refreshCoupon">
					<i class="el-icon-refresh"></i>
					<span>刷新</span>
				</el-button>
			</div>
		</div>
		<div class="grid-content-content">
			<el-alert title="优惠券作废后将不可再恢复，且作废之后已领取的优惠券在有效期内可以继续使用。" type="warning" show-icon :closable="false">
			</el-alert>
		</div>
		<div style="padding: 1.25rem 0;">
			<el-row :gutter="20">
				<el-col :span="6">
					<div class="found">
						<div class="l">
							<div class="name">新人券</div>
							<div class="desc">仅限新用户首单使用的优惠券</div>
							<div class="tag">
								<el-tag type="success" size="mini">拉新</el-tag>
								<el-tag type="info" effect="plain" size="mini">自动发放</el-tag>
							</div>
						</div>
						<div class="r">
							<el-button type="primary" size="mini" @click="addCoupon(1)">新建</el-button>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="found">
						<div class="l">
							<div class="name">公开券</div>
							<div class="desc">在领券页可公开领取的优惠券</div>
							<div class="tag">
								<el-tag size="mini">促转化</el-tag>
								<el-tag type="info" effect="plain" size="mini">通用</el-tag>
								<el-tag type="info" effect="plain" size="mini">自行领取</el-tag>
							</div>
						</div>
						<div class="r">
							<el-button type="primary" size="mini" @click="addCoupon(2)">新建</el-button>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="found">
						<div class="l">
							<div class="name">内部券</div>
							<div class="desc">通过指定用户发放的优惠券</div>
							<div class="tag">
								<el-tag type="warning" size="mini">宠粉</el-tag>
								<el-tag type="info" effect="plain" size="mini">私密券</el-tag>
								<el-tag type="info" effect="plain" size="mini">手动发放</el-tag>
							</div>
						</div>
						<div class="r">
							<el-button type="primary" size="mini" @click="addCoupon(3)">新建</el-button>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="found">
						<div class="l">
							<div class="name">纸质券</div>
							<div class="desc">自由录入定制纸质券</div>
							<div class="tag">
								<el-tag type="danger" size="mini">品牌</el-tag>
								<el-tag type="info" effect="plain" size="mini">合作发放</el-tag>
							</div>
						</div>
						<div class="r">
							<el-button type="primary" size="mini" @click="addCoupon(4)">新建</el-button>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="grid-content-search">
			<div class="line">
				<el-row :gutter="20">
					<el-col :span="9">
						<div class="box">
							<div class="label">优惠券查询：</div>
							<div class="input">
								<el-input v-model="query.keyword" placeholder="请输入关键字" class="input-with-select"
									size="small" clearable>
									<el-select v-model="query.keytype" slot="prepend" placeholder="请选择">
										<el-option label="按批次" value="batch"></el-option>
										<el-option label="按名称" value="title"></el-option>
									</el-select>
								</el-input>
							</div>
						</div>
					</el-col>
					<el-col :span="5">
						<div class="box">
							<div class="label">优惠券类型：</div>
							<div class="input">
								<el-select v-model="query.type" placeholder="请选择" size="small" style="width: 100%;">
									<el-option label="新人券" value="1"></el-option>
									<el-option label="公开券" value="2"></el-option>
									<el-option label="内部券" value="3"></el-option>
									<el-option label="纸质券" value="4"></el-option>
								</el-select>
							</div>
						</div>
					</el-col>
					<el-col :span="10">
						<el-button type="primary" icon="el-icon-search" size="small" style="width: 6rem;" @click="searchCoupon">搜索</el-button>
						<el-button size="small" @click="resetSearchCoupon">重置</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="grid-content-list coupon">
			<div class="common-table">
				<table class="header">
					<colgroup>
						<col width="4%">
						<col>
						<col width="18%">
						<col width="12%">
						<col width="10%">
						<col width="10%">
						<col width="16%">
					</colgroup>
					<thead>
						<tr>
							<th>
								<el-checkbox></el-checkbox>
							</th>
							<th>券信息</th>
							<th>优惠内容限制</th>
							<th>领取量/已使用</th>
							<th>发放量</th>
							<th>状态</th>
							<th>操作</th>
						</tr>
					</thead>
				</table>
				<table class="body" v-loading="(loading && total>0)?true:false">
					<colgroup>
						<col width="4%">
						<col>
						<col width="18%">
						<col width="12%">
						<col width="10%">
						<col width="10%">
						<col width="16%">
					</colgroup>
					<thead>
						<template v-for="(item,index) in list">
							<tr class="separation-row">
								<td colspan="10"></td>
							</tr>
							<tr class="content-row" :class="item.status<=1?'disabled':''">
								<td>
									<div style="display: flex;align-items: center;justify-content: center;">
										<el-checkbox v-model="item.checked"></el-checkbox>
									</div>
								</td>
								<td>
									<div class="info">
										<div class="title">
											<el-tag v-if="item.type==1" type="success" size="mini" effect="dark">新人券</el-tag>
											<el-tag v-if="item.type==2" size="mini" effect="dark">公开券</el-tag>
											<el-tag v-if="item.type==3" type="warning" size="mini" effect="dark">内部券</el-tag>
											<el-tag v-if="item.type==4" type="danger" size="mini" effect="dark">纸质券</el-tag>
											<span>{{item.title}}</span>
										</div>
										<div class="batch">
											<span>批次：{{item.batch}}</span>
											<span style="margin-left: 0.3125rem;cursor: pointer;"
												:class="'copy-'+item.id" class="el-icon-document-copy"
												:data-clipboard-text="item.batch"
												@click="copyBatchCoupon(item.id)"></span>
										</div>
										<div class="frequency">
											<i class="el-icon-warning"></i>
											<span>每人可领取/使用{{item.frequency}}张</span>
										</div>
									</div>
								</td>
								<td>
									<div class="cont">
										<div class="box">
											<div class="a">{{item.content}}</div>
											<div class="b">{{item.out_time}}</div>
										</div>
									</div>
								</td>
								<td>
									<div class="num">{{item.num}}/{{item.used}}</div>
								</td>
								<td>
									<div class="num">{{item.total}}</div>
								</td>
								<td>
									<div v-if="item.status == 0" class="status fail">
										<i class="el-icon-error"></i>
										<span>已作废</span>
									</div>
									<div v-else-if="item.status == 1" class="status fail">
										<i class="el-icon-error"></i>
										<span>已过期</span>
									</div>
									<div v-else-if="item.status == 2" class="status warning">
										<i class="el-icon-warning"></i>
										<span>库存不足</span>
									</div>
									<div v-else-if="item.status == 3" class="status info">
										<i class="el-icon-info"></i>
										<span>库存小于50</span>
									</div>
									<div v-else-if="item.status == 4" class="status success">
										<i class="el-icon-success"></i>
										<span>正常</span>
									</div>
								</td>
								<td>
									<div v-if="item.status<=1" class="operate">
										<el-button plain size="mini" disabled>追加</el-button>
										<el-button type="danger" plain size="mini" disabled>作废</el-button>
									</div>
									<div v-else class="operate">
										<el-button plain size="mini" @click="plusCoupon(index)">追加</el-button>
										<el-button type="danger" plain size="mini" @click="delCoupon(index)"
											:loading="item.del_loading">
											作废
										</el-button>
									</div>
								</td>
							</tr>
						</template>
					</thead>
				</table>
			</div>
			<div v-if="loading && total<=0" style="min-height: 20rem;" v-loading="loading"></div>
			<div v-if="total>0" class="page">
				<el-pagination background layout="total, prev, pager, next" :current-page.sync="page" :total="total"
					@current-change="pageCoupon">
				</el-pagination>
			</div>
			<el-empty v-if="!loading && total<=0" style="height: 20rem;" description="暂无优惠券数据" :image-size="100">
			</el-empty>
		</div>
		<el-drawer :title="drawer_info.form.mode=='plus'?'追加优惠券':'创建优惠券'" :visible.sync="drawer_info.show" size="35%">
			<div class="drawer coupon">
				<el-alert v-if="drawer_info.form.mode!='plus' && drawer_info.form.type==1"
					title="新人券暂时只能创建一张，后续需要作废后才能再次创建" type="warning" show-icon :closable="false"></el-alert>
				<el-alert v-if="drawer_info.form.mode!='plus' && drawer_info.form.type==3" title="内部券只能由用户管理指定用户发放"
					type="warning" show-icon :closable="false"></el-alert>
				<div class="content">
					<el-form class="form" :model="drawer_info.form" :rules="drawer_info.rules" label-position="left"
						label-width="90px" ref="couponInfoForm" size="small" style="margin-top: 1.25rem;">
						<el-form-item label="券类型">
							<div v-if="drawer_info.form.type==1" class="type">新人券</div>
							<div v-if="drawer_info.form.type==2" class="type">公开券</div>
							<div v-if="drawer_info.form.type==3" class="type">内部券</div>
							<div v-if="drawer_info.form.type==4" class="type">纸质券</div>
						</el-form-item>
						<template v-if="drawer_info.form.mode=='plus'">
							<template v-if="drawer_info.form.type==4">
								<el-divider content-position="left" style="margin: 1.25rem 0;">优惠编码</el-divider>
								<el-form-item label="生成编码">
									<el-input v-model="drawer_info.form.code_num" placeholder="请输入需要生成的数量" clearable>
										<el-button slot="append" @click="autoCodeCoupon">生成</el-button>
									</el-input>
								</el-form-item>
								<el-form-item label="编码内容">
									<el-input type="textarea" v-model="drawer_info.form.code" :rows="5"
										placeholder="编码必须12位大小写字母数字，多张请换行" @input="inputCodeCoupon">
									</el-input>
								</el-form-item>
								<el-form-item label="发放数量">
									<div style="display: inline-block;font-weight: bold;color: dodgerblue;">
										{{drawer_info.form.code_total}}
									</div>
									<div style="display: inline-block;margin-left: 0.5rem;">张</div>
								</el-form-item>
							</template>
							<el-form-item v-else label="追加数量">
								<div>
									<div style="display: block;width: 100%;">
										<div style="display: inline-block;">
											<el-input-number v-model="drawer_info.form.num" style="width: 8.125rem;"
												controls-position="right" :min="1" :max="50000" :precision="0">
											</el-input-number>
										</div>
										<div style="display: inline-block;margin-left: 0.5rem;">张</div>
									</div>
									<div style="display: block;font-size: 0.75rem;color: #999;">
										<i class="el-icon-warning"></i>
										<span style="margin-left: 0.25rem;">追加后，只能增加不能减少</span>
									</div>
								</div>
							</el-form-item>
						</template>
						<template v-else>
							<el-form-item label="券名称" prop="title">
								<el-input v-model="drawer_info.form.title" placeholder="请输入优惠券名称" clearable>
								</el-input>
							</el-form-item>
							<el-form-item label="限时使用">
								<el-radio-group v-model="drawer_info.form.limit">
									<el-radio-button label="0">限制有效天数</el-radio-button>
									<el-radio-button label="1">限制有效日期</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<el-form-item v-if="drawer_info.form.limit==0" label="领取之日起">
								<div style="display: inline-block;">
									<el-input-number v-model="drawer_info.form.outday" style="width: 8.125rem;"
										controls-position="right" :min="1" :max="365" :precision="0">
									</el-input-number>
								</div>
								<div style="display: inline-block;margin-left: 0.5rem;">天后过期</div>
							</el-form-item>
							<el-form-item v-if="drawer_info.form.limit==1" label="有效期限">
								<el-date-picker v-model="drawer_info.form.outtime" type="date" value-format="yyyy-MM-dd"
									placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
							<el-divider content-position="left" style="margin: 1.25rem 0;">优惠设置</el-divider>
							<el-form-item label="优惠方式">
								<el-radio-group v-model="drawer_info.form.modes">
									<el-radio-button label="0">满减</el-radio-button>
									<el-radio-button label="1">限额</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<el-form-item v-if="drawer_info.form.modes==0" label="满减面额">
								<div style="display: inline-block;margin-right: 0.5rem;">满</div>
								<div style="display: inline-block;">
									<el-input-number v-model="drawer_info.form.amounta" style="width: 8rem;"
										controls-position="right" :min="0" :max="100" :precision="2">
									</el-input-number>
								</div>
								<div style="display: inline-block;margin: 0 0.5rem;">减</div>
								<div style="display: inline-block;">
									<el-input-number v-model="drawer_info.form.amountb" style="width: 8rem;"
										controls-position="right" :min="1" :max="100" :precision="2">
									</el-input-number>
								</div>
							</el-form-item>
							<el-form-item v-if="drawer_info.form.modes==1" label="限减面额">
								<div style="display: inline-block;margin-right: 0.5rem;">小于</div>
								<div style="display: inline-block;">
									<el-input-number v-model="drawer_info.form.amounta" style="width: 8rem;"
										controls-position="right" :min="0" :max="100" :precision="2">
									</el-input-number>
								</div>
								<div style="display: inline-block;margin: 0 0.5rem;">减</div>
								<div style="display: inline-block;">
									<el-input-number v-model="drawer_info.form.amountb" style="width: 8rem;"
										controls-position="right" :min="1" :max="100" :precision="2">
									</el-input-number>
								</div>
							</el-form-item>
							<el-form-item v-if="drawer_info.form.type!=4" label="券数量">
								<div>
									<div style="display: block;width: 100%;">
										<div style="display: inline-block;">
											<el-input-number v-model="drawer_info.form.num" style="width: 8.125rem;"
												controls-position="right" :min="1" :max="50000" :precision="0">
											</el-input-number>
										</div>
										<div style="display: inline-block;margin-left: 0.5rem;">张</div>
									</div>
									<div style="display: block;font-size: 0.75rem;color: #999;">
										<i class="el-icon-warning"></i>
										<span style="margin-left: 0.25rem;">优惠券创建后，券数量只能增加不能减少</span>
									</div>
								</div>
							</el-form-item>
							<el-form-item label="每人限用">
								<div style="display: inline-block;">
									<el-input-number v-model="drawer_info.form.frequency" style="width: 8.125rem;"
										controls-position="right" :min="1" :max="500" :precision="0">
									</el-input-number>
								</div>
								<div style="display: inline-block;margin-left: 0.5rem;">张</div>
							</el-form-item>
						</template>
					</el-form>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" :loading="drawer_info.loading" @click="submitInfoCoupon">
						{{drawer_info.form.mode == "plus"?"确认追加":"确认创建"}}
					</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import Clipboard from 'clipboard';
	export default {
		data() {
			return {
				loading: true,
				query: {},
				page: 1,
				total: 0,
				list: [],
				drawer_info: {
					show: false,
					loading: false,
					rules: {
						title: [{
							required: true,
							message: '请输入优惠券名称'
						}],
					},
					form: {
						mode: "add",
						id: 0,
						type: 0,
						limit: 0,
						modes: 0,
						title: "",
						outtime: "",
						num: 1,
						outday: 30,
						amounta: 1,
						amountb: 1,
						frequency: 1,
						code: "",
						code_num: "",
						code_total: 0
					}
				}
			};
		},
		created() {
			this.postCoupon();
		},
		methods: {
			searchCoupon() {
				const that = this;
				const query = Object.keys(that.query);
				if (query.length <= 0) {
					that.$message.error("错误：至少需要一个搜索项");
				} else {
					if (that.query.keyword && that.query.keytype == undefined) {
						that.$message.error("错误：请选择关键字类型");
						return;
					}
					if (that.query.keyword == undefined && that.query.keytype) {
						that.$message.error("错误：请输入搜索关键字");
						return;
					}
					that.pageCoupon(1);
				}
			},
			resetSearchCoupon(){
				this.query = {};
				this.pageCoupon(1);
			},
			addCoupon(type) {
				const that = this;
				that.drawer_info.show = true;
				that.drawer_info.loading = false;
				that.drawer_info.form = that.$options.data().drawer_info.form;
				that.drawer_info.form.type = type;
				if(type==4){
					that.drawer_info.form.frequency = 10;
				}
				if (that.$refs.couponInfoForm != undefined) {
					that.$refs.couponInfoForm.resetFields();
				}
			},
			plusCoupon(index) {
				//追加
				const that = this;
				that.drawer_info.show = true;
				that.drawer_info.loading = false;
				that.$set(that.drawer_info, 'form', {
					mode: "plus",
					id: that.list[index].id,
					type: that.list[index].type,
					num: 1,
					code_total: 0
				});
				if (that.$refs.couponInfoForm != undefined) {
					that.$refs.couponInfoForm.resetFields();
				}
			},
			submitInfoCoupon() {
				const that = this;
				that.$refs.couponInfoForm.validate((valid) => {
					if (valid) {
						that.drawer_info.loading = true;
						that.$post('marketingCoupon', that.drawer_info.form).then(res => {
							that.drawer_info.show = false;
							that.$message.success((that.drawer_info.form.mode == 'plus') ? "追加成功" :
								"创建成功");
							setTimeout(function() {
								that.pageCoupon(1);
							}, 500);
						}).catch(e => {
							that.drawer_info.loading = false;
							that.$alert((e != undefined && e.message != undefined && e.message) ? e
								.message :
								"未知错误，请重试", '提示', {
									type: 'error',
									confirmButtonText: '确定'
								});
						});
					} else {
						return false;
					}
				});
			},
			copyBatchCoupon(id) {
				const that = this;
				var clipboard = new Clipboard('.copy-' + id);
				clipboard.on('success', e => {
					that.$message.success("复制成功");
					clipboard.destroy();
				});
				clipboard.on('error', e => {
					that.$message.error("复制失败，请手动复制");
					clipboard.destroy();
				});
			},
			delCoupon(index) {
				const that = this;
				that.$confirm('作废后已领取的券有效期内可继续使用，是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.list[index].del_loading = true;
					that.$post('marketingCoupon', {
						mode: "del",
						id: that.list[index].id
					}).then(res => {
						that.list[index].del_loading = false;
						that.$message.success("作废成功");
						setTimeout(function() {
							that.pageCoupon(1);
						}, 500);
					}).catch(e => {
						that.list[index].del_loading = false;
						that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
							"未知错误，请重试", '提示', {
								type: 'error',
								confirmButtonText: '确定'
							});
					});
				}).catch(() => {});
			},
			autoCodeCoupon() {
				const that = this;
				const nums = parseInt(that.drawer_info.form.code_num);
				if (Object.is(nums, NaN)) {
					that.$message.error("错误：请正确输入生成数量");
					return;
				}
				if (nums < 1) {
					that.$message.error("错误：单次最少生成1张优惠券编码");
					return;
				}
				if (nums > 5000) {
					that.drawer_info.form.code_num = 5000;
					that.$message.error("错误：单次最多只能生成5000张优惠券编码");
					return;
				}
				var code = "";
				for (var i = 0; i < nums; i++) {
					if (i == (nums - 1)) {
						code += generateMixed(12);
					} else {
						code += generateMixed(12) + "\n";
					}
				}
				that.drawer_info.form.code = code;
				that.drawer_info.form.code_total = nums;
			},
			inputCodeCoupon() {
				const that = this;
				var code = that.drawer_info.form.code.split(/[(\n)\n]+/);
				var total = 0;
				for (var i = 0; i < code.length; i++) {
					if (code[i].length >= 12) {
						total++;
					}
					if (i == (code.length - 1) && code[i].length >= 13) {
						let str = code[i].substr(code[i].length - 1, 1);
						that.drawer_info.form.code = that.drawer_info.form.code.substr(0, that.drawer_info.form.code
							.length - 1);
						that.drawer_info.form.code += "\n" + str;
					}
				}
				that.drawer_info.form.code_total = total;
			},
			refreshCoupon() {
				this.pageCoupon(1);
			},
			pageCoupon(e) {
				this.page = e;
				this.postCoupon(this.query);
			},
			postCoupon(query = {}) {
				const that = this;
				that.loading = true;
				that.$post('marketingCoupon', {
					query: query,
					page: that.page
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.total = res.data.total;
						res.data.list.map((item) => {
							item.checked = false;
							item.del_loading = false;
							return item;
						});
						that.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
	//生成随机数
	function generateMixed(n) {
		var chars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J",
			"K",
			"L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f",
			"g", "h",
			"i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"
		];
		var res = "";
		for (var i = 0; i < n; i++) {
			var id = Math.ceil(Math.random() * 61);
			res += chars[id];
		}
		return res;
	}
</script>

<style scoped>
	.found {
		display: flex;
		padding: 0.9375rem;
		border: 1px solid #edeef0;
		border-radius: 4px;
	}

	.found .l {
		flex: 1;
	}

	.found .l .name {
		font-size: 0.9375rem;
		font-weight: bold;
	}

	.found .l .desc {
		color: #999;
		font-size: 0.75rem;
		margin-top: 0.125rem;
	}

	.found .l .tag {
		display: flex;
		align-items: center;
		height: 1.5rem;
		margin-top: 1.25rem;
	}

	.found .l .tag .el-tag+.el-tag {
		margin-left: 5px;
	}

	.found .r {
		display: flex;
		align-items: center;
	}
	
	.coupon .content-row.disabled {
		opacity: 0.5;
	}

	.coupon .info {
		padding: 10px;
	}

	.coupon .info .title {
		font-size: 0.875rem;
		color: #576b95;
	}
	
	.coupon .info .title span:nth-child(2) {
		font-weight: bold;
		margin-left: 0.25rem;
	}

	.coupon .info .batch,
	.coupon .info .frequency {
		font-size: 0.75rem;
		margin-top: 0.125rem;
	}

	.coupon .info .batch {
		color: #999;
	}
	
	.coupon .info .frequency i {
		margin-right: 0.125rem;
	}

	.coupon .cont,
	.coupon .outtime,
	.coupon .num,
	.coupon .status,
	.coupon .operate {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.875rem;
		padding: 10px;
	}

	.coupon .cont .a {
		font-size: 0.875rem;
		text-align: center;
	}

	.coupon .cont .b {
		color: #999;
		font-size: 0.75rem;
		text-align: center;
	}

	.coupon .status i {
		margin-right: 0.15rem;
	}

	.coupon .status {
		font-size: 0.8125rem;
	}

	.coupon .status.success {
		color: #07C160;
	}

	.coupon .status.warning {
		color: #F56C6C;
	}

	.coupon .status.info {
		color: #E6A23C;
	}

	.coupon .status.fail {
		color: #FF0000;
	}

	.drawer.coupon .type {
		color: #576b95;
	}

	.drawer.coupon .drawer-footer {
		border-top: 1px #f0f0f0 solid;
	}
</style>
